import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { AddNewRole } from "../config/RoleApi";
import { toast } from "react-toastify";
import paths from "routes/paths";
import { Button, Col, Form, Row } from "react-bootstrap";
import FalconComponentCard from "components/common/FalconComponentCard";
import BackButton from "components/common/custom/back-button";
import TextInput from "components/common/custom/forms/BootTextField/TextField";

const AddUpdateRole = ({ view }) => {
  const dispatch = useDispatch();
  const { singleRoleData } = useSelector((state) => state.roleAdmin);
  const {
    control,
    watch,
    setValue,
    reset,
    handleSubmit,
    formState: { errors, isSubmitted },
  } = useForm({
    defaultValues: {},
  });
  const navigate = useNavigate();

  const { id } = useParams();

  const handleReset = () => {
    setValue("role_name", "");
    reset();
  };

  useEffect(() => {
    if (!id) return;
    if (id) {
      setValue("role_name", singleRoleData?.role_name || "");
    }
  }, [id]);

  const handleAddRole = async (data) => {
    const payload = {
      ...(id && { role_id: id }),
      role_name: data?.role_name,
    };
    const response = await dispatch(AddNewRole(payload)).unwrap();
    if (response?.success) {
      toast.success(response?.message_en);
      navigate(paths.systemPrivillage);
    } else {
      toast.error(response?.message_en);
      navigate(paths.systemPrivillage);
    }
  };
  return (
    <Form noValidate onSubmit={handleSubmit(handleAddRole)} className="p-0">
      <FalconComponentCard
        className="shadow-md"
        style={{ position: "relative" }}
      >
        <FalconComponentCard.Header
          className="d-flex  fixed-header justify-content-between align-items-center"
          sx={{
            position: "sticky !important",
            top: 68,
            zIndex: 1020,
            backgroundColor: "white",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          }}
        >
          <BackButton
            path={paths.systemPrivillage}
            title={`${id ? (view ? "View" : "Update") : "Add"} Role`}
          />
          <Col xs="auto m-0">
            <h5 className="text-primary mb-0 fs-10"></h5>
          </Col>
          <Col xs="auto" className="d-flex gap-2">
            {!view && (
              <>
                <Button
                  size="sm"
                  variant="outline-danger"
                  onClick={handleReset}
                >
                  Reset
                </Button>
                <Button type="submit" size="sm" variant="success">
                  {id ? "Update" : "Add"}
                </Button>
              </>
            )}
          </Col>
        </FalconComponentCard.Header>
        <FalconComponentCard.Body
          style={{
            marginTop: "40px", // Adjust this value based on header height
            overflowY: "auto",
            maxHeight: "calc(100vh - 200px)", // Adjust based on your needs
          }}
        >
          <Row alignItems="center">
            <Col xs={12} sm={6} md={4} xl={3}>
              <TextInput
                name="role_name"
                label="Role Name"
                control={control}
                placeholder="Role Name"
                size="sm"
                errors={errors}
                disabled={view}
                required={true}
                rules={{
                  required: true,
                }}
              />
            </Col>
          </Row>
        </FalconComponentCard.Body>
      </FalconComponentCard>
    </Form>
  );
};

export default AddUpdateRole;
